var App = App || {};

App.Animations = (function ($) {

    'use strict';

    function ScrollAnimate() {
        $(".widget.widget-homepage-banner .homepage-olb-box-wrapper").ZagScrollAnimate({
            offset: 75,
            targets: [
                { selector: ".homepage-olb-box", type: "animate__fadeInRight", stagger: 0 }
            ],
            overflow: true
        });

        $(".widget.widget-homepage-banner .navigation-carousel").ZagScrollAnimate({
            offset: 85,
            targets: [
                { selector: ".carousel-navigation", type: "animate__fadeInUp", stagger: 0 }
            ],
            overflow: false
        });

        $(".widget.widget-solutions-finder").ZagScrollAnimate({
            offset: 75,
            targets: [
                { selector: ".solution-link-wrapper, .inline-yext-search", type: "animate__fadeInUp", stagger: 200 }
            ],
            overflow: false
        });

        $(".widget.widget-blog-feature-band").ZagScrollAnimate({
            offset: 75,
            targets: [
                { selector: ".blogpost-card", type: "animate__fadeInUp", stagger: 200 }
            ],
            overflow: false
        });

        $(".widget.widget-testimonials-band").ZagScrollAnimate({
            offset: 75,
            targets: [
                { selector: ".testimonials-band-inner", type: "animate__fadeInUp", stagger: 0 }
            ],
            overflow: false
        });

        $(".widget.widget-community-band").ZagScrollAnimate({
            offset: 75,
            targets: [{ selector: ".icon-wrapper", type: "animate__fill", stagger: 0 }],
            overflow: false
        });

        $(".widget.widget-detail-masthead").ZagScrollAnimate({
            offset: 75,
            targets: [{ selector: ".masthead-feature", type: "animate__fadeInUp", stagger: 250 }],
            overflow: false
        });

        $(".widget.widget-page-promo").ZagScrollAnimate({
            offset: 75,
            targets: [{ selector: ".page-promo-inner", type: "animate__fadeInUp", stagger: 0 }],
            overflow: false
        });

        $(".widget.widget-location-callout").ZagScrollAnimate({
            offset: 75,
            targets: [{ selector: ".location-callout-inner", type: "animate__fadeInUp", stagger: 0 }],
            overflow: false
        });

        $(".widget.widget-category-masthead").ZagScrollAnimate({
            offset: 75,
            targets: [
                { selector: ".category-masthead-img", type: "animate__fadeInUp", stagger: 0 },
                { selector: ".category-masthead-content", type: "animate__fadeIn", stagger: 0 }
            ],
            overflow: false
        });

        $(".widget.widget-category .widget-category-list").ZagScrollAnimate({
            offset: 75,
            targets: [
                { selector: ".widget-category-list-item", type: "animate__fadeIn", stagger: 250 }
            ],
            overflow: false
        });

        $(".widget.widget-landing-masthead").ZagScrollAnimate({
            offset: 75,
            targets: [
                { selector: ".landing-masthead-media", type: "animate__fadeInUp", stagger: 0 }
            ],
            overflow: false
        });

        $(".widget.widget-blog-main-masthead").ZagScrollAnimate({
            offset: 75,
            targets: [
                { selector: ".life-stage-link-wrapper", type: "animate__fadeInUp", stagger: 250 }
            ],
            overflow: false
        });

        $(".section.section-blog-lifestage").ZagScrollAnimate({
            offset: 75,
            targets: [
                { selector: ".life-stage-list", type: "animate__fadeInUp", stagger: 0 }
            ],
            overflow: false
        });

        $(".widget.widget-blog-post-masthead").ZagScrollAnimate({
            offset: 75,
            targets: [
                { selector: ".masthead-card", type: "animate__fadeInUp", stagger: 0 }
            ],
            overflow: false
        });

        $(".widget.widget-related-articles").ZagScrollAnimate({
            offset: 75,
            targets: [
                { selector: ".blog-post-card-wrapper", type: "animate__fadeInUp", stagger: 200 }
            ],
            overflow: false
        });

        $(".widget.widget-faq-filter-navigation").ZagScrollAnimate({
            offset: 75,
            targets: [
                { selector: ".faq-filter-nav-card-wrapper", type: "animate__fadeInUp", stagger: 125 }
            ],
            overflow: false
        });
    }

    return {
        ScrollAnimate: ScrollAnimate
    };

})(jQuery);

$(function () {
    App.Animations.ScrollAnimate();
});